import axios from '@/axios.js'

export default {
  /**
   * @param {{ from: string, to: string, groupBy?: string, page?: number, perPage?: number }} params Date-only YYYY-MM-DD for from/to (admin API contract).
   */
  async fetchMetrics ({ from, to, groupBy = 'platform', page = 1, perPage = 20 }) {
    const response = await axios.adminapi.get('v4/campaigns/push-delivery-metrics', {
      params: {
        from,
        to,
        group_by: groupBy,
        page,
        per_page: perPage
      }
    })
    return response.data.object
  },

  /**
   * @param {{ from: string, to: string }} params Date-only YYYY-MM-DD
   * @returns {Promise<import('axios').AxiosResponse<Blob>>}
   */
  async downloadExport ({ from, to }) {
    return axios.adminapi.get('v4/campaigns/push-delivery-metrics/export', {
      params: { from, to },
      responseType: 'blob'
    })
  }
}
